import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

/** Centred, branded card used by sign-in and the password screens. */
export default function AuthLayout({ title, subtitle, children, onSubmit }) {
  return (
    <Box className="login-wrap">
      <Card
        component="form"
        onSubmit={onSubmit}
        noValidate={false}
        sx={{
          width: '100%', maxWidth: 400, borderTop: '4px solid', borderTopColor: 'primary.main',
          boxShadow: '0 12px 40px rgba(18, 56, 113, 0.10)',
        }}
      >
        <CardContent sx={{ p: { xs: 3, sm: 4 }, '&:last-child': { pb: { xs: 3, sm: 4 } } }}>
          <Box component="img" src={`${process.env.PUBLIC_URL}/brand/logo-full.svg`}
               alt="Cloudmyle - AI, Web, Mobile, Cloud, Digital Marketing"
               sx={{ display: 'block', width: 220, maxWidth: '80%', mx: 'auto', mb: 3 }} />
          <Typography variant="h6" align="center" color="primary" sx={{ fontSize: 17 }}>
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" align="center" color="text.secondary" sx={{ mt: 0.5, mb: 2.5 }}>
              {subtitle}
            </Typography>
          )}
          {children}
        </CardContent>
      </Card>
    </Box>
  );
}
